/**
 * Keeps the Shopify Forms embed (the "10 % Rabatt" teaser) inside the theme's
 * stacking order. The app pins its container at z-index 2147483647 inside a
 * shadow root, so base.css gives the host element its own stacking context at
 * --layer-promo-widget. Once the visitor opens the form it becomes a modal
 * dialog and has to sit on top again; this flags that state on the host.
 */
const HOST = 'shopify-forms-embed';
const watched = new WeakSet();
const pending = new WeakSet();

/** @param {Element} host */
function sync(host) {
  const expanded = !!host.shadowRoot?.querySelector('[role="dialog"]');
  host.toggleAttribute('data-promo-expanded', expanded);
}

/**
 * @param {Element} host
 * @param {number} [attempt]
 */
function watch(host, attempt = 0) {
  if (watched.has(host) || (attempt === 0 && pending.has(host))) return;

  // The shadow root can be attached a while after the host lands in the DOM.
  if (!host.shadowRoot) {
    pending.add(host);
    if (attempt < 20) setTimeout(() => watch(host, attempt + 1), 250);
    return;
  }

  watched.add(host);
  new MutationObserver(() => sync(host)).observe(host.shadowRoot, { childList: true, subtree: true });
  sync(host);
}

function scan() {
  document.querySelectorAll(HOST).forEach(watch);
}

// App embeds inject late and outside the theme's markup.
new MutationObserver(scan).observe(document.body, { childList: true });
scan();
